import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MasterNewformComponent } from './master-newform.component';

const routes: Routes = [
  {
    path: '',
    component: MasterNewformComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterNewformRoutingModule {}
